import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { LoginModel } from "../../../common/utils";

const initialState: LoginModel = {
  email: "",
  isLogin: false,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setUserEmail: (state: LoginModel, action: PayloadAction<string>) => {
      state.email = action.payload;
    },

    setIsLogin: (state: LoginModel, action: PayloadAction<boolean>) => {
      state.isLogin = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserEmail, setIsLogin } = loginSlice.actions;

export default loginSlice.reducer;
